import { actionError } from "@/lib/error-code";

const wikiErrorLabel: Record<string, string> = {
	CONFLICT: "Já existe uma página com esse título.",
	NOT_FOUND: "Página não encontrada.",
};

export const WikiLabels = {
	title: "Wiki",
	subtitle: "Referências da clínica",
	newPage: "Nova página",
	searchPlaceholder: "Buscar por título",
	emptyIndex: "nenhuma página ainda",
	noMatch: "nenhum título com essa busca",
	pickPage: "Nenhuma página selecionada",
	emptyTitle: "A wiki está em branco",
	titlePlaceholder: "Título da página",
	contentPlaceholder: "Escreva a página em markdown",
	previewEmpty: "nada para visualizar ainda",
	create: "Criar página",
	save: "Salvar",
	cancel: "Cancelar",
	edit: "Editar",
	history: "Histórico",
	historyTitle: "Histórico",
	loading: "Carregando página...",
	indexError: "Não foi possível carregar o índice.",
	createError: "Não foi possível criar a página.",
	conflict: "Já existe uma página com esse título.",
	pageLoadError: "Não foi possível carregar a página.",
	historyLoadError: "Não foi possível carregar o histórico.",
	noRevisions: "Nenhuma revisão anterior.",
	revisionLabel(author: string) {
		return `versão de ${author}`;
	},
	updatedBy(author: string) {
		return `atualizada por ${author}`;
	},
	tabs: [
		{ value: "write" as const, label: "Escrever" },
		{ value: "preview" as const, label: "Visualizar" },
	],
	error(code: string | undefined) {
		return actionError(wikiErrorLabel, code);
	},
};
